import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ServiceAreas from '../components/ServiceAreas';
import Services from '../components/Services';
import ProjectGallery from '../components/ProjectGallery';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import SocialMediaSection from '../components/SocialMediaSection';
import BookingSection from '../components/BookingSection';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/sonner';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <ServiceAreas />
      <Services />
      <ProjectGallery />
      <WhyChooseUs />
      <Testimonials />
      <SocialMediaSection />
      <BookingSection />
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};

export default Home;
